import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";

export default function BundleSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [credits, setCredits] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!sessionId) {
      setLoading(false);
      return;
    }
    const finalize = async () => {
      try {
        const { data } = await api.post(`/bundle/finalize/${sessionId}`);
        if (data?.is_paid) {
          const { data: c } = await api.get("/bundle/credits");
          setCredits(c);
          toast.success(data.already_granted ? "Bundle credits already applied to your account." : "Bundle activated! Your credits are ready.");
        } else {
          toast.error("Payment not confirmed yet. Please refresh in a moment.");
        }
      } catch (e) {
        toast.error(e?.response?.data?.detail || "Could not finalize bundle.");
      } finally {
        setLoading(false);
      }
    };
    finalize();
  }, [sessionId]);

  if (loading) return <div style={{ padding: 80, textAlign: "center", color: "var(--text-muted)" }}>Activating your bundle…</div>;

  return (
    <div style={{ maxWidth: 720, margin: "60px auto", padding: "0 24px", textAlign: "center" }} data-testid="bundle-success-page">
      <div style={{ fontSize: 64, marginBottom: 16 }}>💎</div>
      <div style={{ fontSize: 11, letterSpacing: "0.3em", color: "var(--gold)", marginBottom: 6 }}>COMPLETE MEMORIAL PACK</div>
      <h1 className="serif" style={{ fontSize: 42, color: "#fff", margin: "0 0 8px", fontWeight: 400 }}>Your bundle is active</h1>
      <p className="muted" style={{ fontSize: 15, marginBottom: 32, lineHeight: 1.7 }}>
        Your credits are loaded onto your account. The next time you generate a slideshow, rhyming poem, or send a sympathy gift, the credit will be applied automatically — no extra checkout needed.
      </p>

      {credits && (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: 14, marginBottom: 32 }}>
          <div style={{ padding: 18, background: "#0f0f10", border: "1px solid #2a2a2a", borderRadius: 12 }}>
            <div style={{ fontSize: 32, marginBottom: 6 }}>▶</div>
            <div className="serif" style={{ fontSize: 18, color: "#fff", marginBottom: 4 }}>Slideshow Video</div>
            <div style={{ color: "var(--gold)", fontSize: 13, fontWeight: 700 }}>{credits.slideshow} credit{credits.slideshow === 1 ? "" : "s"}</div>
          </div>
          <div style={{ padding: 18, background: "#0f0f10", border: "1px solid #2a2a2a", borderRadius: 12 }}>
            <div style={{ fontSize: 32, marginBottom: 6 }}>📜</div>
            <div className="serif" style={{ fontSize: 18, color: "#fff", marginBottom: 4 }}>Rhyming Poem</div>
            <div style={{ color: "var(--gold)", fontSize: 13, fontWeight: 700 }}>{credits.poem} credit{credits.poem === 1 ? "" : "s"}</div>
          </div>
          <div style={{ padding: 18, background: "#0f0f10", border: "1px solid #2a2a2a", borderRadius: 12 }}>
            <div style={{ fontSize: 32, marginBottom: 6 }}>💌</div>
            <div className="serif" style={{ fontSize: 18, color: "#fff", marginBottom: 4 }}>Sympathy Gift</div>
            <div style={{ color: "var(--gold)", fontSize: 13, fontWeight: 700 }}>{credits.gift} credit{credits.gift === 1 ? "" : "s"}</div>
          </div>
        </div>
      )}

      <Link to="/dashboard" className="btn-gold" data-testid="bundle-back-dashboard" style={{ padding: "14px 28px", textDecoration: "none" }}>
        Back to my obituaries →
      </Link>
    </div>
  );
}
